var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value:
            _vm.shippingAddress &&
            !_vm.isLoadingAddresses &&
            !_vm.isLoadingShippingAddress,
          expression:
            "shippingAddress && !isLoadingAddresses && !isLoadingShippingAddress"
        }
      ]
    },
    [
      _c("h2", [_vm._v("Mon mode de livraison")]),
      _vm._v(" "),
      0 === _vm.choices.length
        ? _c("div", [_vm._v("Pas de moyens de livraisons disponibles")])
        : _c(
            "div",
            _vm._l(_vm.choices, function(choice) {
              return _c(
                "div",
                [
                  _c("ponroy-order-input-carrier", {
                    key: choice.value,
                    attrs: {
                      value: choice.value,
                      name: _vm.name,
                      id: _vm.id,
                      countries: JSON.parse(choice.attr["data-countries"]),
                      isColissimo: _vm.isColissimo(choice.attr["data-type"]),
                      isRelay: _vm.isRelay(choice.attr["data-type"]),
                      label: choice.label
                    },
                    model: {
                      value: _vm.carrier,
                      callback: function($$v) {
                        _vm.carrier = $$v
                      },
                      expression: "carrier"
                    }
                  })
                ],
                1
              )
            })
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e55637f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e55637f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/SiteBundle/Resources/assets/components/Order/OrderCarrier.vue
// module id = 552
// module chunks = 1